import {reqWithToken} from './requestHelper';

//crud

export async function insert(insert) {
    return (await reqWithToken('api/japanese',{
        method: 'post',
        data: insert
    })).data;
}

export async function getstud() {

    return (await reqWithToken('api/japanese/studentdata')).data;
}

export async function get(id) {
    return (await reqWithToken(`api/japanese/${id}`,)).data;
}



export async function getAll() {
    return (await reqWithToken('api/japanese')).data;
}

export async function getstudentAll() {
    return (await reqWithToken('api/japanese/getstudentAll')).data;
}

export async function update(update) {
    return (await reqWithToken('api/japanese',{
        method: 'put',
        data: update
    })).data;
}

export async function remove(id) {
    return (await reqWithToken('api/japanese/',{
        method: 'delete',
        params: {id}
    })).data;
}

export async function getFormActionByInfo(update) {
    return (await reqWithToken('api/japanese/getFormActionByInfo',{
        method: 'put',
        data: update
    })).data;
}